export const SET_SELECTED_ADDRESS = 'meta:SET_SELECTED_ADDRESS'
export const SET_SELECTED_VALUE = 'meta:SET_SELECTED_VALUE'
export const TOGGLE_SOUND_SFX = 'meta:SET_SOUND_SFX'
export const TOGGLE_SOUND_MUSIC = 'meta:SET_SOUND_MUSIC'
export const ADD_TRANSACTION_ID = 'meta:ADD_TRANSACTION_ID'
